import { withProfiler as withSentryProfiler } from '@sentry/react';
import { ComponentType, FC } from 'react';

import { OBSERVABILITY_ENV } from '@constants/config';

const withProfiler = <P extends Record<string, unknown>>(
  Component: ComponentType<P>
): FC<P> | ComponentType<P> => {
  // Using the profiler has an impact on performance and should not be used in production.
  if (OBSERVABILITY_ENV === 'production') {
    return Component;
  }

  return withSentryProfiler(Component);
};

export { withProfiler };
